import React from "react"
import TooltipMaxLength from "../../../hooks/utils/TooltipMaxLength"
import { formatDateShortIntl2 } from "../../../helpers/FormatDate"
import { defaultProfileImage } from "../../../utils/constants"

export type TicketResponse = {
  id: number
  waitingList: number
  targetEmail: string
  targetName: string
  createdBy: number
  note: string
  status: 'open' | 'closed' | 'pending'
  createdAt: string
  updatedAt: string
}

type Props = {
  data: TicketResponse[]
  select: (id:number) => void
  userId:number
}

export const TicketList: React.FC<Props> = ({ data, select, userId }) => {
  return (
    <div className="waitinglist-task-table">
      <div className="waitinglist-task-table__header">
        <div>Date</div>
        <div>Note</div>
        <div>Status</div>
        <div>Nobilis Admin</div>
      </div>

      {data.map((row, index) => (
        <div key={index} className="waitinglist-task-table__row" onClick={()=>select(row.id)}>
          <div className="waitinglist-task-table__cell">
            {formatDateShortIntl2(row.createdAt)}
          </div>

          <div className="waitinglist-task-table__cell">
            <TooltipMaxLength
              text={row.note}
              maxLength={80}
              maxWidth={380}
              position="bottom"
            />
          </div>

          <div className="waitinglist-task-table__cell">
            {row.status}
          </div>

          <div className="waitinglist-task-table__cell card-profile-avatar">
            <img src={row?.admin?.avatar || defaultProfileImage} alt={row?.admin?.name} />
            <span>{row.targetEmail}</span>
          </div>
        </div>
      ))}
    </div>
  )
}